import { render, staticRenderFns } from "./KnowYourTariff.vue?vue&type=template&id=5207f20b&scoped=true&"
import script from "./KnowYourTariff.vue?vue&type=script&lang=js&"
export * from "./KnowYourTariff.vue?vue&type=script&lang=js&"
import style0 from "./KnowYourTariff.vue?vue&type=style&index=0&id=5207f20b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5207f20b",
  null
  
)

export default component.exports